/* **********************************************V2 *********************************************************/
/* NOTE: i ll set with this version for now, since it works much better on refreshes
* 			and with the vue updates on save */
const API_KEY = 'AIzaSyAg1Y8c0SddLQVOdudo9joxRkLx_fZFJD8'
const CALLBACK_NAME = 'initMap'

function buildScriptToDynamicLoad () {
	var script = document.createElement('script')
	script.type = 'text/javascript'
	script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&loading=async&callback=${CALLBACK_NAME}`
	document.querySelector('head').appendChild(script)
}

export const mapApiLoader = () => {
	if (window.google) { return Promise.resolve(window.google) }
	return new Promise((resolve, reject) => {
		buildScriptToDynamicLoad()
		window[CALLBACK_NAME] = () => {
			resolve(window.google)
		}
		setTimeout(() => {
			if (!window.google) {
				reject(new Error('Loading took too long'))
			}
		}, 5000)
	})
}
